<script lang="ts">
  import sections from "$lib/docs/guide/sections.json";
  import SideSection from "$routes/(docs)/docs/_components/SideSection.svelte";
  import ThreeColumn from "$routes/(docs)/docs/_components/ThreeColumn.svelte";
  import type { DocsSection } from "$routes/(docs)/docs/_lib/sections";

  const typedSections = sections as DocsSection[];
</script>

<ThreeColumn>
  <svelte:fragment slot="sidebar-links">
    {#each typedSections as section}
      <SideSection {section} />
    {/each}
  </svelte:fragment>
  <slot />
</ThreeColumn>
